import { RemarkButton } from '@Components/IconButton';
import Remark from '@Components/Remark';
import { createPortal } from 'react-dom';
import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';
import {
  IGhGasEmissionVerifyFormValues,
  IPerformanceGhGasMgmtReportFormValues,
} from '../../EsgGreenhouseFormProvider/types';
import { useDisclosure } from '@hooks/useDisclosure';
import { useWatch } from 'react-hook-form';
import { Box } from '@mui/material';

export const GH_GAS_EMISSION_VERIFY_REMARK_ID = 'gh-gas-emission-verify-remark';

const GreenhouseGasEmissionVerifyRemark = () => {
  const { control, getValues } = useGreenhouseForm();
  const { remark } =
    getValues(`performanceGhGasMgmtReport.ghGasEmissionVerify`) ??
    ({} as IGhGasEmissionVerifyFormValues);

  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const ghGasEmissionVerifyRemarkEl = document.getElementById(
    GH_GAS_EMISSION_VERIFY_REMARK_ID
  );

  const { completedSection } =
    useWatch({
      name: 'performanceGhGasMgmtReport',
      control,
    }) ?? ({} as IPerformanceGhGasMgmtReportFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};
  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        ghGasEmissionVerifyRemarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              onDelete={close}
              topic="การทวนสอบปริมาณการปล่อยก๊าซเรือนกระจกของบริษัทในรอบปีที่ผ่านมา"
              setOpen={open}
              fieldPath="performanceGhGasMgmtReport.ghGasEmissionVerify.remark"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          ghGasEmissionVerifyRemarkEl
        )}
    </>
  );
};

export default GreenhouseGasEmissionVerifyRemark;
